import { render, staticRenderFns } from "./UserCash.vue?vue&type=template&id=66620fc4&scoped=true&"
import script from "./UserCash.vue?vue&type=script&lang=js&"
export * from "./UserCash.vue?vue&type=script&lang=js&"
import style0 from "./UserCash.vue?vue&type=style&index=0&id=66620fc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66620fc4",
  null
  
)

export default component.exports